import { render, staticRenderFns } from "./playlists-tab.vue?vue&type=template&id=2e4226f1"
import script from "./playlists-tab.vue?vue&type=script&lang=js"
export * from "./playlists-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports